import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import UserForm from './pages/UserForm';
import Categories from './pages/Categories';
import CategoryForm from './pages/CategoryForm';
import Products from './pages/Products';
import ProductForm from './pages/ProductForm';
import Attributes from './pages/Attributes';
import Discounts from './pages/Discounts';
import DiscountForm from './pages/DiscountForm';
import Inquiries from './pages/Inquiries';
import Settings from './pages/Settings';
import Reports from './pages/Reports';
import Orders from './pages/Orders';
import Payments from './pages/Payments';
import Reviews from './pages/Reviews';
import Blogs from './pages/Blogs';
import BlogForm from './pages/BlogForm';

import CommunicationSupport from './pages/CommunicationSupport';
import { AuthProvider, useAuth } from './contexts/AuthContext';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <Box>Loading...</Box>;
  }
  
  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            
            {/* User Management Routes */}
            <Route path="users" element={<Users />} />
            <Route path="users/add" element={<UserForm />} />
            <Route path="users/edit" element={<UserForm />} />
            
            {/* Category Management Routes */}
            <Route path="categories" element={<Categories />} />
            <Route path="categories/add" element={<CategoryForm />} />
            <Route path="categories/edit" element={<CategoryForm />} />
            
            {/* Product Management Routes */}
            <Route path="products" element={<Products />} />
            <Route path="products/add" element={<ProductForm />} />
            <Route path="products/edit" element={<ProductForm />} />
            
            {/* Blog Management Routes */}
            <Route path="blogs" element={<Blogs />} />
            <Route path="blogs/new" element={<BlogForm mode="create" />} />
            <Route path="blogs/edit/:id" element={<BlogForm mode="edit" />} />


            
            <Route path="attributes" element={<Attributes />} />
            <Route path="discounts" element={<Discounts />} />
            <Route path="discounts/add" element={<DiscountForm />} />
            <Route path="discounts/edit/:id" element={<DiscountForm />} />
            <Route path="orders" element={<Orders />} />
            <Route path="payments" element={<Payments />} />
            <Route path="inquiries" element={<Inquiries />} />
            <Route path="reviews" element={<Reviews />} />
            <Route path="communication" element={<CommunicationSupport />} />
            <Route path="settings" element={<Settings />} />
            <Route path="reports" element={<Reports />} />
          </Route>
        </Routes>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
